export default __webpack_public_path__ + "static/imgSSM1-7af2db65a3c6d420d9f622dd8c1c1bd3.png";